module.exports = __webpack_public_path__ + "img/wave.8f818d2c.svg";